(function () {
    'use strict';

    const module = angular.module('imApp');

    module.component('subscriptionUsergroupEdit', {
        templateUrl: 'views/components/views/subscriptionUsergroupEdit/subscriptionUsergroupEdit.template.html?v=' + module.version,
        controllerAs: 'vm',
        bindings: {
            p2SubscriptionUsergroupKeyno: '<?',
            onSave: '&'
        },
        controller: ['$stateParams', 'stateService', 'subscriptionUsergroupEditService', 'layoutService', function ($stateParams, stateService, subscriptionUsergroupEditService, layoutService) {

            // #region VARIABLES & DEFINITIONS

            const vm = this;
            let p2SubscriptionUsergroupKeyno = vm?.p2SubscriptionUsergroupKeyno ?? $stateParams.p2_subscription_usergroup_keyno;
            let tabletSize = layoutService.getMediaQueries().tablet;
            
            vm.model = {
                tabletSize: tabletSize,
                edit: {},
                lockedSave: false
            };

            // #endregion VARIABLES & DEFINITIONS

            // #region LOAD PROCEDURE CALL

            let loadEdit = function () {
                subscriptionUsergroupEditService.getEdit({ p2_subscription_usergroup_keyno: p2SubscriptionUsergroupKeyno }).then(function (info) {
                    angular.copy(info[0], vm.model.edit);
                });
            };

            // #endregion LOAD PROCEDURE CALL

            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

            vm.saveChanges = function () {
                vm.model.lockedSave = true;

                subscriptionUsergroupEditService.saveObj(vm.model.edit).then(function () {
                    vm.model.lockedSave = false;

                    if (angular.isFunction(vm.onSave) && tabletSize.matches === true && vm.p2SubscriptionUsergroupKeyno > 0) {
                        vm.onSave();
                    } else {
                        stateService.back();
                    }
                }, function () {
                    vm.model.lockedSave = false;
                });
            };

            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

            // #region ON INIT FUNCTION

            vm.$onInit = function () {
                //loadEdit();
            };

            // #endregion ON INIT FUNCTION

            // #region ON CHANGES FUNCTION

            vm.$onChanges = function (changes) {
                if (changes?.p2SubscriptionUsergroupKeyno?.currentValue) {
                    p2SubscriptionUsergroupKeyno = changes.p2SubscriptionUsergroupKeyno.currentValue;
                }

                if (p2SubscriptionUsergroupKeyno) loadEdit();
            };

            // #endregion ON CHANGES FUNCTION

        }]
    });
})();
